import React from "react";
import {BrowserRouter as Router, Route, Switch} from "react-router-dom";
import {Login} from "../pages/login";
import {CreateAccount} from "../pages/create-account";
import {NotFound} from "../pages/404";


export const LoggedOutRouter = () => {
    return <Router>
        <Route>
            <Switch>
                <Route path="/create-account">
                    <CreateAccount/>
                </Route>
                <Route path="/" exact={true}>
                    <Login/>
                </Route>
                <Route>
                    <NotFound/>
                </Route>
            </Switch>
        </Route>
    </Router>
}
    
